export class ApplicationPropertyValue {
  FieldKey: string;
  Value: any;
}
